var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgVideo = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 80 80",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 40,
    r: 39,
    fill: "#000",
    fillOpacity: 0.303,
    stroke: "#FFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M48.27506 38.73896l-14.4985-9.43925c-.53208-.34544-1.23842-.39746-1.82161-.12902-.58784.26636-.95495.80742-.95495 1.39217v18.87226c0 .59099.36711 1.12996.95495 1.39632.24861.11237.52046.16856.79463.16856.35781 0 .72028-.10197 1.02698-.30382l14.4985-9.43093c.45773-.30174.72494-.76787.72494-1.26314.0023-.5036-.27186-.96765-.72494-1.26315z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVideo, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/video.3d31060f.svg";
export { ForwardRef as ReactComponent };